import React from 'react';
import Raft from '../Raft/Raft';
import panelStyles from '../ArtifactPanel/ArtifactPanel.module.css';
import MessageContent from '../ConversationPanel/MessageContent';
import classnames from 'classnames';
import { AssistantArtifact } from 'components/framework/models';
import viewStyles from '../AssistantView/AssistantView.module.css';
import headerStyles from '../HeaderPanel/HeaderPanel.module.css';
import styles from './ArtifactViewer.module.css';

// Content types without padding.
const NON_CENTERED_CONTENT_TYPES = [
  'text/html',
  'application/vnd.aha.bookmark',
  'application/vnd.aha.react',
];

function toggleEmbeddedFullScreen(element) {
  if (!document.fullscreenElement) {
    // If the document is not in full screen mode
    // make the video full screen
    element.requestFullscreen();
  } else {
    // Otherwise exit the full screen
    document.exitFullscreen?.();
  }
}

const ArtifactViewer = ({ artifactData, domain, embed = false, openUrl }) => {
  const artifact = new AssistantArtifact(artifactData);
  const containerRef = React.useRef(null);

  return (
    <div ref={containerRef}>
      <Raft size={'full-screen'} noPopover>
        <div className={viewStyles.container}>
          <div
            className={classnames(
              headerStyles.header,
              headerStyles.fullScreen,
              styles.artifactViewerHeader,
              {
                [styles.artifactViewerHeaderEmbed]: embed,
              }
            )}
          >
            <div className={styles.artifactViewerHeaderLeft}>
              <a
                href={embed ? openUrl : undefined}
                target='_blank'
                rel='noopener noreferrer'
                className={classnames(
                  headerStyles.headerTitle,
                  styles.artifactViewerHeaderLink
                )}
              >
                <aha-ai-icon size={embed ? 14 : 17} />
                AI assistant
              </a>
            </div>
            <div className={styles.artifactViewerWarning}>
              This artifact is AI-generated for {domain}.aha.io and might
              contain unsafe content.
            </div>
            <div className={styles.artifactViewerHeaderLeft}>
              {!embed && (
                <span className='tw-font-medium'>
                  {artifact.fileName || 'Artifact Viewer'}
                </span>
              )}
              {embed && (
                <aha-button
                  kind='icon'
                  size='mini'
                  onClick={() => toggleEmbeddedFullScreen(containerRef.current)}
                >
                  <i className='fa-solid fa-up-right-and-down-left-from-center' />
                </aha-button>
              )}
            </div>
          </div>
          <React.Fragment key={artifact.uniqueId}>
            <div
              className={classnames(panelStyles.artifactBody, {
                [styles.artifactBodyCentered]:
                  !NON_CENTERED_CONTENT_TYPES.includes(
                    artifact.contentType || 'text/plain'
                  ),
              })}
            >
              <MessageContent
                body={artifact.content || ''}
                contentType={artifact.contentType || 'text/plain'}
              />
            </div>
          </React.Fragment>
        </div>
      </Raft>
    </div>
  );
};

export default ArtifactViewer;
